module.exports = __webpack_public_path__ + "img/delete-discussion.d83ffc70.svg";